export default {
  SET_VISITOR_INFO: (state, payload) => {
    if (payload.pageList !== undefined) {
      state.pageList = payload.pageList
    }
    if (payload.updatedAt !== undefined) {
      state.updatedAt = payload.updatedAt
    }
    if (payload.visitor !== undefined) {
      state.visitor = payload.visitor
    }
  },
  SET_PORTAL_CODE: (state, code) => {
    if (code) {
      state.portalCode = code
    }
  }
}
